export default "__VITE_ASSET__DUjtC7Ns__"